import { TranscoderVideoProfile, TranscoderAudioProfile, TranscoderProfile, TranscoderTemplate } from '@vxui/common';
import { TableColumn } from 'react-data-table-component';
import { SelectChangeEvent } from '@mui/material';
import { ReactNode } from 'react';
import { TFunction } from 'i18next';
import { AudioProfileOnSelectProps, VideoProfileOnSelectProps } from '../forms/profileForm.types';

export type AudioTableProps = {
  data: TranscoderAudioProfile[];
  isLoading: boolean;
  actions: TableColumn<TranscoderAudioProfile>[];
  editableRows: TranscoderAudioProfile[];
  singleProfileToDelete?: TranscoderAudioProfile;
  onColumnChange: (row: TranscoderProfile) => void;
  onSelectChange: ({ event, row, field, type }: AudioProfileOnSelectProps) => void;
  onSingleCloseDeleteHandler: () => void;
};

export type VideoTableProps = {
  data: TranscoderVideoProfile[];
  isLoading: boolean;
  actions: TableColumn<TranscoderVideoProfile>[];
  editableRows: TranscoderVideoProfile[];
  profileToDelete?: TranscoderVideoProfile;
  onColumnChange: (row: TranscoderProfile) => void;
  onResolutionChange: (event: SelectChangeEvent, row: TranscoderProfile) => void;
  onCodecChange: (event: SelectChangeEvent, row: TranscoderProfile) => void;
  onSelectChange: ({ event, row, field, type }: VideoProfileOnSelectProps) => void;
  onCloseDeleteModalHandler: () => void;
};

export const enum EInputType {
  text = 'text',
  number = 'number',
}

export const isVideoProfile = (object: TranscoderProfile | undefined): object is TranscoderVideoProfile => {
  return !!object && 'resolution' in object;
};

export type CellProps<T> = {
  fieldName: string;
  onChangeHandler: (event: SelectChangeEvent, row: TranscoderProfile) => void;
  row: TranscoderProfile;
  placeholder?: string;
  value?: T;
  disabled?: boolean;
};
export type CellSelectBoxProps<T> = CellProps<T> & {
  items: ReactNode[];
};

export type SimplifiedTemplate = Pick<TranscoderTemplate, 'id' | 'name'>;

export type AudioTableColumnsProps = {
  t: TFunction;
  actions: TableColumn<TranscoderAudioProfile>[];
  onChangeHandler: (row: TranscoderProfile) => void;
  onSelectChangeHandler: ({ event, row, field, type }: AudioProfileOnSelectProps) => void;
  editableRows?: TranscoderAudioProfile[];
};

export type VideoTableColumnsProps = {
  t: TFunction;
  actions: TableColumn<TranscoderVideoProfile>[];
  onChangeHandler: (row: TranscoderProfile) => void;
  onResolutionChangeHandler: (event: SelectChangeEvent, row: TranscoderProfile) => void;
  onCodecChangeHandler: (event: SelectChangeEvent, row: TranscoderProfile) => void;
  onSelectChangeHandler: ({ event, row, field, type }: VideoProfileOnSelectProps) => void;
  editableRows?: TranscoderVideoProfile[];
};
